import { Avatar } from '@mui/joy';
import { Box } from '@mui/material';

const Profile = 'assets/images/Mask group (11).png';

const FundiBidCard = () => {

    return (
      <Box
        sx={{
          position: 'relative',
  
          width:'42.59px',
          height: '42.59px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
  
        }}
      >
  
        <Avatar
          src={Profile}
          alt="User"
          sx={{
            width:'38.73px',
            height:'38.73px',
            margin: '0 auto'
          }}
        />
  
        <Box
          sx={{
            position: 'absolute',
         
            width:'42.59px' ,
            height:'42.59px' ,
            borderRadius: '50%',
            border:'0.5px solid #2E2E2E',
            boxSizing: 'border-box',
      
         
          }}
        />
      </Box>
    );
  };

  export default FundiBidCard;